import { Commit } from 'vuex';

import StoreUtil from '@store/StoreUtil';

export interface PopoversState {
    isFtdReminderVisible: boolean;
}

const SET_IS_FTD_REMINDER_VISIBLE = 'SET_IS_FTD_REMINDER_VISIBLE';

const popoversStore = {
    namespaced: true,
    state: {
        isFtdReminderVisible: false,
    } as PopoversState,
    mutations: {
        [SET_IS_FTD_REMINDER_VISIBLE]: StoreUtil.createSimpleMutator('isFtdReminderVisible'),
    },
    actions: {
        showFtdReminder({ commit }: { commit: Commit }) {
            commit(SET_IS_FTD_REMINDER_VISIBLE, true);
        },
        hideFtdReminder({ commit }: { commit: Commit }) {
            commit(SET_IS_FTD_REMINDER_VISIBLE, false);
        },
    },
    getters: {
        isFtdReminderVisible(state: PopoversState) {
            return state.isFtdReminderVisible;
        },
    },
};

export default popoversStore;

type PopoversStore = typeof popoversStore;

export {
    PopoversStore,
};
